import Status from '@ingka/status';
import type { ApprovalStatus as ApprovalStatusType } from '@lotta/shared/types-lottery-schemas';
import { useTranslation } from 'react-i18next';

export type ApprovalStatusProps = {
  approvalStatus: ApprovalStatusType;
};

export const ApprovalStatus = ({ approvalStatus }: ApprovalStatusProps) => {
  const { t } = useTranslation();

  switch (approvalStatus) {
    case 'APPROVED':
      return <Status statusColor="green" small label={`${t('home-approval-status-approved')}`} />;
    case 'DENIED':
      return <Status statusColor="red" small label={`${t('home-approval-status-denied')}`} />;
    case 'WAITING':
      return <Status statusColor="orange" small label={`${t('general-pending')}`} />;
    default:
      return <Status statusColor="grey" small label={`${t('general-unknown')}`} />;
  }
};
